





















import { Vue, Component, Prop, Watch } from 'vue-property-decorator';

@Component
export default class Accordion extends Vue {
  @Prop({ default: false }) disabled: boolean;
  @Prop({ default: null }) isOpen: boolean;
  @Prop({ default: false }) showBorder: boolean;
  @Prop({ default: false }) showShadow: boolean;
  expanded = false;

  @Watch('isOpen', { immediate: true })
  watchingIsOpen(isOpen: boolean) {
    if (this.isOpen !== null) {
      this.expanded = isOpen;
    }
  }

  handleToggle(expanded: boolean) {
    this.expanded = expanded;
    this.$emit('toggle', expanded);
  }
}
